import {ALookupRowsContainer} from "./lookup.rows.container";
import {SpsItem} from "./sps.item";
import {SpsXPps} from "./sps.x.pps";
import {LinkedSps} from "../../patient/models/linkedSps";


export class Sps extends ALookupRowsContainer {
	static spsXPps_TYPE;
	static spsItem_TYPE;

	spsId: number;
	spsCodeKey: number;
	modalityKey: number;
	startDatetime: Date;
	spsItem: SpsItem[];
	spsXPps: SpsXPps[];
	duration: number;
	durationModifier: number;
	description: string;
	pacsSpsId: string;
	scheduledByResourceIdKey: number;
	statusKey: number;
	appointmentId: number;
	requestedProcedureId: number;
	validationErrorLevel? : number;
	earlyAppointmentRequest: string; // 'Y' / 'N'
	seriesSequenceId: number;
	linkedSps:LinkedSps[];
	linkedId: number;

	protocolKey;
	protocolCommentsCbS;
	contrastIvAmountRadCbS: number;
	contrastIvUnitRadCbS: number;
	contrastIvNameRadCbS: number;
	protocoledByResourceIdCbS: number;
	protocoledDateCbS: Date;
	modalityScheduleGroupKey: number;

	isCurrentContextSps?: boolean; //This field is used for distinguishing the selected WL row's SPS from other SPSs in the same order,
	// when editing an appointment (we use this field for auto-selecting this study and separately scheduling it)

	lateralityKey: number;
	
	// get studyPACSDemoAccession() {
	// 	let accessionPpsLink = {
	// 		'9275000123456':9276017127544,
	// 		'9275000039531':9276017127564,
	// 		'2013519187930':9276017127905,
	// 		'9275000039533':9276017127569,
	// 		'9275100039533':9276017127584,
	// 		'9275000124578':9276017127567,
	// 		'9275000454545':9276017127906,
	// 		'9275000121212':9276017127568,
	// 		'9275000039524':9276017127907,
	// 		'88776655':9276017127908,
	// 		'55443322':9276017127945,
	// 		'66554433':9276017127946,
	// 		'9275000039537':9276017127947,
	// 		'9275000039586':9276017127948,
	// 		'9275000039584':9276017127969,
	// 		'9275000039541':9276017127954,
	// 		'9275000039609':9276017127953,
	// 		'9275000039554':9276017127952,
	// 		'9276000000006':9276017127951,
	// 		'9275000041932':9276017127950,
	// 		'9275000039507':9276017127949,
	// 		'11553288':9276017127565,
	// 		'2011082464':9276017127885,
	// 		'7001451005':9276017127566,
	// 		'31629903':9276017127909};
	//
	// 	if (accessionPpsLink[this.pacsSpsId]) {
	// 		return this.pacsSpsId;
	// 	} else {
	// 		return '9275000039531';
	// 	}
	// }
	//

	// get firstSpsXPps() {
	// 	// let prop = 'spsXPps';
	// 	// if (!this[prop] || !this[prop][0]) {
	// 	// 	this[prop] = [{}];
	// 	// }
	// 	// return this[prop][0];
	// 	return {};
	// }

	// public SetData(spsCode?: ISPSCodeBaseLookup, procedureCode?: IProcedureCode) {
	// 	this.spsCodeKey = spsCode.spsCodeKey;
	// 	this.duration = spsCode.duration;
	// 	this.description = spsCode.description;
	// 	this.FKLookupRows = {spsCodeKey: spsCode};
	//
	// 	let spsItem = new SpsItem();
	// 	let sequenceId = this.getNextSequenceId();
	// 	spsItem.SetData(procedureCode, sequenceId);
	// 	this.spsItem = [spsItem];
	// }

	// public AddProcedureToSpsItem(procedureCode: IProcedureCode) {
	// 	let currSpsItem: SpsItem;
	// 	if (this.spsItem) {
	// 		//Check if sps item array contain the procedureCode.
	// 		currSpsItem = this.spsItem.find((spsItem) => {
	// 			return procedureCode.procedureCodeKey === spsItem.procedureCodeKey;
	// 		});
	// 	} else {
	// 		this.spsItem = [];
	// 	}
	//
	// 	if (!currSpsItem) {
	// 		//Add a new sps item.
	// 		let createSpsItem = new SpsItem();
	// 		createSpsItem.SetData(procedureCode, this.getNextSequenceId());
	// 		this.spsItem.push(createSpsItem);
	// 	}
	// }
	//
	// public RemoveProcedureFromSpsItem(procedureCode: IProcedureCode){
	// 	if (this.spsItem) {
	// 		let spsItemIndex = this.spsItem.findIndex((spsItem) => {
	// 			return procedureCode.procedureCodeKey === spsItem.procedureCodeKey;
	// 		});
	//
	// 		if (spsItemIndex > -1){
	// 			this.spsItem.splice(spsItemIndex, 1);
	// 		}
	// 	}
	// }

	// public getNextSequenceId(){
	// 	return (this.spsItem && this.spsItem.length) ? this.spsItem[this.spsItem.length - 1].sequenceId + 1 : 1;
	// }
}
Sps.spsXPps_TYPE = SpsXPps;
Sps.spsItem_TYPE = SpsItem;
